import { render, staticRenderFns } from "./TrainingFile.vue?vue&type=template&id=56a48976&scoped=true"
import script from "./TrainingFile.vue?vue&type=script&lang=js"
export * from "./TrainingFile.vue?vue&type=script&lang=js"
import style0 from "./TrainingFile.vue?vue&type=style&index=0&id=56a48976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a48976",
  null
  
)

export default component.exports